export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Week Adapter: Make the Pack Fit Your Schedule',
    body: 'Practice three days a week? Six? Only 45 minutes after school, or a two-hour block? See exactly which practices to merge, which to skip and how to stretch or compress the clock, so the pack fits your room instead of the other way around.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b62c466a-89fe-4c4f-9c19-f6e1efb1f1fa.jpg',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'First Practice Countdown: 14 Days to Day One',
    body: 'Fourteen days, one short task a day, and you walk into practice one with the room set up, the two tracks sorted, your staff on the same page and nothing left to figure out.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ea29d3b8-4dd2-4dd6-b995-75c654615042.jpg',
    accent: 'bg-gold',
  },
  {
    number: '03',
    title: 'No-Mat Day Plans',
    body: 'Lost the gym to a basketball game or the mats to another team? Five ready practices for a hallway, a cafeteria or a classroom, with no falls and no takedowns to the floor, that still move your wrestlers forward.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/da995ca1-f849-412e-821d-4c8bfca60178.jpg',
    accent: 'bg-coral',
  },
  {
    number: '04',
    title: 'Catch-Up Cards for Wrestlers Who Miss Practice',
    body: 'Ten one-page home sessions to hand to any healthy wrestler who misses practice or is away over the holidays, so they come back moving the way the room does.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7ccae834-fd2b-469d-b74f-ae7fed1a6da1.jpg',
    accent: 'bg-block-a',
  },
  {
    number: '05',
    title: 'Freestyle Season Guide',
    body: 'Coaching in Canada, the UK or Australia, or running a spring freestyle club? See what changes on the mat, which block of each volume to swap, and how to order the six volumes in a freestyle season.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4aecc2f0-68ec-4514-b4dc-5aa03486c197.jpg',
    accent: 'bg-block-b',
  },
]
